import { BaseCanvas } from "@visactor/vrender-core";

import { WxContext2d } from "./context";

export class WxCanvas extends BaseCanvas {
    constructor(params) {
        super(params);
    }
    init() {
        this._context = new WxContext2d(this, this._dpr);
    }
    release(...params) {}
}

WxCanvas.env = "wx";
//# sourceMappingURL=canvas.js.map
